import { render, staticRenderFns } from "./HeaderBody.vue?vue&type=template&id=670f91b3&scoped=true&"
import script from "./HeaderBody.vue?vue&type=script&lang=js&"
export * from "./HeaderBody.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBody.vue?vue&type=style&index=0&id=670f91b3&scoped=true&lang=css&"
import style1 from "./HeaderBody.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670f91b3",
  null
  
)

export default component.exports